var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasRtb
    ? _c(
        "PortalWidget",
        {
          attrs: { widget: _vm.widget },
          scopedSlots: _vm._u(
            [
              {
                key: "headerContent",
                fn: function() {
                  return [_c("div", { staticClass: "header-extra" })]
                },
                proxy: true
              }
            ],
            null,
            false,
            1325076107
          )
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rtb-dashboard p-b-30" },
            [_c("RtbExport"), _vm._v(" "), _c("RtbSearch")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row row--bs-margin rtb-stats" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 m-b-15" },
              [
                _c("RtbStatsByPublisher", {
                  staticClass: "rtb-stats__widget--alt"
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 m-b-15" },
              [
                _c("RtbStatsRejectionByPublisher", {
                  staticClass: "rtb-stats__widget--alt"
                })
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }